import { useRoute, useRouter } from 'vue-router'
import { computed } from 'vue'
import { compact } from 'ramda-adjunct'
import { GroupKey, Groups } from '@/config'

export const useSearchParam = () => {
  const router = useRouter()
  const route = useRoute()

  return computed({
    get: () => (route.query.search ?? '') as string,
    set: (value) => router.replace({ query: compact({ ...route.query, search: value || undefined }) }),
  })
}

export const useGroupParam = () => {
  const route = useRoute()

  return computed(() => route.query.group as GroupKey | undefined ?? '')
}
